import { http } from "./http";
import type { Organization } from "./auth.service";

export interface ProjectTemplateRef {
  id: string;
  key: string;
  name: string;
  modules?: string[];
}

export type ProjectVisibility = "private" | "organization" | "public";

export interface ProjectSettings {
  locale?: string;
  timezone?: string;
  app_port?: number;
  git_init?: boolean;
}

export interface ProjectPreviewRef {
  id: string;
  status: string;
  url: string | null;
  last_accessed_at: string | null;
}

export interface Project {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  status: string;
  visibility?: ProjectVisibility;
  workspace_ready?: boolean;
  framework_version?: string | null;
  last_activity_at: string | null;
  created_at: string | null;
  organization?: Organization;
  owner?: { id?: string; name?: string };
  template?: ProjectTemplateRef | null;
  template_version?: string | null;
  template_modules?: string[];
  last_preview?: ProjectPreviewRef | null;
}

export const projectService = {
  list: () => http.get<Project[]>("/projects"),
  get: (id: string) => http.get<Project>(`/projects/${id}`),
  create: (payload: {
    name: string;
    description?: string;
    organization?: string;
    template?: string;
    modules?: string[];
    visibility?: ProjectVisibility;
    settings?: ProjectSettings;
  }) =>
    http.post<Project>("/projects", payload),
  duplicate: (id: string) => http.post<Project>(`/projects/${id}/duplicate`),
  archive: (id: string) => http.post<Project>(`/projects/${id}/archive`),
  remove: (id: string) => http.delete<{ message: string }>(`/projects/${id}`),
};
